import { render, staticRenderFns } from "./BotaoSalvar.vue?vue&type=template&id=71d0c541"
import script from "./BotaoSalvar.vue?vue&type=script&lang=js"
export * from "./BotaoSalvar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports